module.exports = __webpack_public_path__ + "img/JKO.40a7f9a2.png";